import {makeStyles} from '@mui/styles';

export default makeStyles(() => ({
  main: {
    alignContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'calc(100vh)',
    marginTop: '0px',
    objectFit: 'fill',
    backgroundColor: '#2b3836',
  },
}));
